<div class="drag-boundary"></div>
<router-outlet></router-outlet>
